// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file sync.proto (syntax proto3)
/* eslint-disable */

import type { Message as Message$1 } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file sync.proto.
 */
export const file_sync: GenFile /*@__PURE__*/ = fileDesc(
  'CgpzeW5jLnByb3RvIjoKDUVuY3J5cHRlZERhdGESCgoCaXYYASABKAwSDwoHYXV0aFRhZxgCIAEoDBIMCgRkYXRhGAMgASgMIkYKB01lc3NhZ2USDwoHZGF0YXNldBgBIAEoCRILCgNyb3cYAiABKAkSDgoGY29sdW1uGAMgASgJEg0KBXZhbHVlGAQgASgJIkoKD01lc3NhZ2VFbnZlbG9wZRIRCgl0aW1lc3RhbXAYASABKAkSEwoLaXNFbmNyeXB0ZWQYAiABKAgSDwoHY29udGVudBgDIAEoDCJ2CgtTeW5jUmVxdWVzdBIiCghtZXNzYWdlcxgBIAMoCzIQLk1lc3NhZ2VFbnZlbG9wZRIOCgZmaWxlSWQYAiABKAkSDwoHZ3JvdXBJZBgDIAEoCRINCgVrZXlJZBgFIAEoCRINCgVzaW5jZRgGIAEoCUoECAQQBSJCCgxTeW5jUmVzcG9uc2USIgoIbWVzc2FnZXMYASADKAsyEC5NZXNzYWdlRW52ZWxvcGUSDgoGbWVya2xlGAIgASgJYgZwcm90bzM',
);

/**
 * @generated from message EncryptedData
 */
export type EncryptedData = Message$1<'EncryptedData'> & {
  /**
   * @generated from field: bytes iv = 1;
   */
  iv: Uint8Array;

  /**
   * @generated from field: bytes authTag = 2;
   */
  authTag: Uint8Array;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;
};

/**
 * Describes the message EncryptedData.
 * Use `create(EncryptedDataSchema)` to create a new message.
 */
export const EncryptedDataSchema: GenMessage<EncryptedData> /*@__PURE__*/ =
  messageDesc(file_sync, 0);

/**
 * @generated from message Message
 */
export type Message = Message$1<'Message'> & {
  /**
   * @generated from field: string dataset = 1;
   */
  dataset: string;

  /**
   * @generated from field: string row = 2;
   */
  row: string;

  /**
   * @generated from field: string column = 3;
   */
  column: string;

  /**
   * @generated from field: string value = 4;
   */
  value: string;
};

/**
 * Describes the message Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> /*@__PURE__*/ = messageDesc(
  file_sync,
  1,
);

/**
 * @generated from message MessageEnvelope
 */
export type MessageEnvelope = Message$1<'MessageEnvelope'> & {
  /**
   * @generated from field: string timestamp = 1;
   */
  timestamp: string;

  /**
   * @generated from field: bool isEncrypted = 2;
   */
  isEncrypted: boolean;

  /**
   * @generated from field: bytes content = 3;
   */
  content: Uint8Array;
};

/**
 * Describes the message MessageEnvelope.
 * Use `create(MessageEnvelopeSchema)` to create a new message.
 */
export const MessageEnvelopeSchema: GenMessage<MessageEnvelope> /*@__PURE__*/ =
  messageDesc(file_sync, 2);

/**
 * @generated from message SyncRequest
 */
export type SyncRequest = Message$1<'SyncRequest'> & {
  /**
   * @generated from field: repeated MessageEnvelope messages = 1;
   */
  messages: MessageEnvelope[];

  /**
   * @generated from field: string fileId = 2;
   */
  fileId: string;

  /**
   * @generated from field: string groupId = 3;
   */
  groupId: string;

  /**
   * @generated from field: string keyId = 5;
   */
  keyId: string;

  /**
   * @generated from field: string since = 6;
   */
  since: string;
};

/**
 * Describes the message SyncRequest.
 * Use `create(SyncRequestSchema)` to create a new message.
 */
export const SyncRequestSchema: GenMessage<SyncRequest> /*@__PURE__*/ =
  messageDesc(file_sync, 3);

/**
 * @generated from message SyncResponse
 */
export type SyncResponse = Message$1<'SyncResponse'> & {
  /**
   * @generated from field: repeated MessageEnvelope messages = 1;
   */
  messages: MessageEnvelope[];

  /**
   * @generated from field: string merkle = 2;
   */
  merkle: string;
};

/**
 * Describes the message SyncResponse.
 * Use `create(SyncResponseSchema)` to create a new message.
 */
export const SyncResponseSchema: GenMessage<SyncResponse> /*@__PURE__*/ =
  messageDesc(file_sync, 4);
